import { BKJThemeColorType } from '@awais4123/fillify-design-library';
import { AccessStatusEnum } from 'types/graphql';

export const getJaneColorByStatus = (status: AccessStatusEnum): BKJThemeColorType => {
  switch (status) {
    case 'approved':
      return 'SecondaryAcceptedDefault';
    default:
      return 'Grey6';
  }
};
